import axios from "axios";
import qs from "qs";
import { refreshToken } from "../services/authService";
import { logoutCompletely } from "../utils/logoutCompletely";

const API_ENTRY = axios.create({
  baseURL:
    process.env.REACT_APP_ENTRY_API || "https://stage-dev.tx-portal.com/entry",
  headers: { "Content-Type": "application/json" },
  paramsSerializer: (params) => qs.stringify(params, { arrayFormat: "repeat" }),
});

API_ENTRY.interceptors.request.use((config) => {
  const token = localStorage.getItem("accessToken");
  if (token && config.headers) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

API_ENTRY.interceptors.response.use(
  (response) => response,
  async (error) => {
    const originalRequest = error.config;
    if (error.response?.status === 401 && !originalRequest._retry) {
      originalRequest._retry = true;
      try {
        const newToken = await refreshToken();
        localStorage.setItem("accessToken", newToken);
        originalRequest.headers.Authorization = `Bearer ${newToken}`;
        return API_ENTRY(originalRequest);
      } catch (err) {
        logoutCompletely();
        return Promise.reject(err);
      }
    }
    return Promise.reject(error);
  }
);

export default API_ENTRY;
